module.exports = __webpack_public_path__ + "static/media/MovieTv.a8781e8d.gif";